import { systemConstants } from "../_constants";

const initialState = {};

export function system(state = initialState, action : any) {
    switch (action.type) {
        default:
            return state;
    }
}